import { render, staticRenderFns } from "./status-badge.vue?vue&type=template&id=3fd2d54c&scoped=true"
import script from "./status-badge.vue?vue&type=script&lang=js"
export * from "./status-badge.vue?vue&type=script&lang=js"
import style0 from "./status-badge.vue?vue&type=style&index=0&id=3fd2d54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2d54c",
  null
  
)

export default component.exports